<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h1"><span>A Word About Sources</span></p>
<p class="indent">The story you are about to read is true. It spans two states and twenty years.</p>
<p class="indent">Interviews, official documents, statements to police and reporters, as well as newspaper articles, have all been used in the writing of this book. In the event that two participants offer differing, noncorroborating accounts of the same event, the author has used his journalistic prerogative to choose which version to present.</p>
<p class="indent">Dialogue has been extracted from the author’s interviews, court documents, Singleton’s murder trial, and newspaper articles. Some scenes have been dramatically recreated to portray episodes that occurred. A few scenes might be presented out of chronological order to simplify the narrative. Likewise, the Singleton investigation involved many police officers and for the sake of clarity, the story is presented principally through the eyes of the lead police officers.</p>
<p class="indent">The author has chosen to change the names of some individuals to afford them privacy. Any similarity between those fictitious names used and those of living persons or dead is purely coincidental.</p>
<p class="indent">I’d like to thank Captain Richard Breshears of the Stanislaus County Sheriff’s Office in California, and Vilma Bean of the Hillsborough County Sheriff’s Office in Florida for their invaluable assistance in writing this book, and Kensington Editor-in-chief Paul Dinas for his patience and guidance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?5559d1e0